import debounce from "lodash/debounce";

function windowScroll() {
    "use strict";

    Cookies.set("viewport", window.scrollY > 0 ? window.scrollY : 2, {
        path: "/",
        secure: true,
        sameSite: "None"
    });
}

export function viewportCachingCreate() {
    "use strict";

    window.addEventListener("scroll", debounce(windowScroll, 320));
}

export function viewportCachingRemove() {
    "use strict";

    Cookies.set("viewport", 0, {
        path: "/",
        secure: true,
        sameSite: "None"
    });
    window.removeEventListener("scroll", windowScroll);
}

export function getCachedViewport() {
    "use strict";

    setTimeout(function () {
        $(window).scrollTop(Cookies.get("viewport"));
    }, 1000);
}
